module.exports = __webpack_public_path__ + "static/media/cert_129.78c5f3e1.jpg";